module.exports = __webpack_public_path__ + "img/Logo-Valora.58589d39.png";